export const API_BASE_URL_ = `${process.env.REACT_APP_API_URL}/courses`;

export const API_BASE_URL = (id: string | undefined) =>
  `${process.env.REACT_APP_API_URL_RESSOURCES}/chapters/${id}`;
